import { Pagination, SuccessResponse } from "common/common.interface";
import {
  Family,
  FamilyWithMembers,
  CreateFamilyPayload,
  FamilyBalance,
} from "modules/family/types/family.interface";
import { Client } from "modules/client/types/client.interface";

export interface FamilyBackend {
  getFamilies(
    page: number,
    limit: number,
    search: string | undefined
  ): Promise<Pagination<FamilyWithMembers>>;
  getFamily(id: string): Promise<FamilyWithMembers>;
  createFamily(
    workspaceId: string,
    payload: CreateFamilyPayload
  ): Promise<Family>;
  updateFamily(id: string, payload: CreateFamilyPayload): Promise<Family>;
  archiveFamily(id: string): Promise<SuccessResponse>;
  addMember(familyId: string, clientId: string): Promise<Client>;
  removeMember(familyId: string, clientId: string): Promise<Client>;
  getFamilyBalance(familyId: string): Promise<FamilyBalance>;
}

let familyBackendInstance: FamilyBackend | undefined;

export async function getFamilyBackend(): Promise<FamilyBackend> {
  if (familyBackendInstance === undefined) {
    // Always use production backend for families
    const mod = await import("./production");
    familyBackendInstance = new mod.default() as FamilyBackend;
  }
  return familyBackendInstance;
}
